<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card ">
                <div class="card-body">
                    <p>Borlaug is a blockchain for advancing sustainability. Borlaug supports sustainability compliance assessments to ensure whether a business or value chain partner complies with
                        national and international standards on sustainability issues.</p>

                    <p>Following are key stakeholers that benefit from Borlaug blockchain.</p>

                    <h3>Farmers</h3>
                    <p>With full availability of sourcing data, farmers will be able to view the audit and quality
                        reports of their farm inputs with GAP certificates, USDA Organic, HACCP, Fairtrade etc. Showcasing
                        the audited provenance data of the produce lends credibility and showcases the self-sustainability of
                        the farm. With regular inspection for compliance by auditors’ farms as a whole becomes certified.
                        Farmers can be assured of guaranteed payment upon delivery and quality verification. This
                        automatically increases customer base due to security of fund transactions.</p>

                    <h3>Farm Co-ops</h3>
                    <p>Cooperatives are formed by individual farmers and small landholders coming together with
                        the common intention of selling their produce to trustworthy buyers at a fair price. By pooling
                        supply purchases, sales, handling and selling expenses, cooperatives can operate more efficiently at
                        lower costs per unit than farmers individually. Even reduces per unit handling and processing cost by
                        assembling large volumes of produce. Produce of each farm is directly traded through negotiations
                        in the marketplace by the co-ops to credit approved buyers.
                        Farmers are distributed net savings made in handling, processing and selling operations. Results in
                        expanded customer base as the reach of individual farmers increases exponentially. Coops bring
                        more to the market at a higher producer price along with assurance of dependable and steady
                        source of supplies to buyers.</p>

                    <h3>Buyers</h3>
                    <p>Buyers in this case can be wholesalers, big retail chains, distributors etc, who get origin-
                        verified, certified and audited tradable commodities for immediate buying in the marketplace.
                        Buyers can even verify the trades with the help of smart contracts and escrow services. This
                        guarantees security, availability and quality of purchase too. Buyer negotiates and transacts directly
                        with seller. Buyers will be able to keep track of the produce and verify the authenticity of claims
                        made by producers for their produce. Efficiency and traceability improve and goes a long way
                        towards assuring food safety and security.</p>

                    <h3>Auditors</h3>
                    <p>Auditors conduct sustainability and production audits on the farm based on structured
                        and harmonious data provided. Audits not only improve the efficiency of production but unlocks
                        profitability and sustainable production along with social and environmental accountability. Audit is
                        based on standardized parameters with the full audit trail and exception report visible to all.
                        Regulatory compliance gets achieved along with unperturbed retail acceptance. Opens up more
                        market opportunities. Generated audit reports as well as the sustainability certifications will be
                        available for buyers to see.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Stakeholders"
    }
</script>

<style scoped>

</style>